import { Component, Input, Output, EventEmitter } from '@angular/core';
@Component({
	selector: 'modal',
	templateUrl: "./modal.html",
	styles: [require("./modal.scss")]
})
export class Modal {
	@Input() title: string;
	@Input() msg: string;
	@Output() yes: EventEmitter<any> = new EventEmitter();
	@Output() no: EventEmitter<any> = new EventEmitter();
	@Input() visible: boolean;

	public yesClicked() {
		this.yes.emit("yes");
	}

	public noClicked() {
		this.no.emit("no");
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/modal/modal.component.ts